import { useEffect, useRef } from 'react'

import { InputContainer } from '../../Input'
import { InputMultiSelectControlContent } from '../InputMultiSelectControlContent'
import { useSelectContext } from '../Select.hooks'
import { SelectControl } from '../SelectControl'
import { SelectControlSelectedItemsCounter } from '../SelectControlSelectedItemsCounter'

function InputMultiSelectControl({
  Container = InputContainer,
  Content = InputMultiSelectControlContent,
  contentProps,
  indicatorsProps,
  ref,
  ...restProps
}) {
  const { blocked, disabled, error, isOpen } = useSelectContext()

  const inputRef = useRef(null)

  useEffect(() => {
    if (isOpen) {
      inputRef?.current?.focus()
    }
  }, [isOpen])

  return (
    <SelectControl
      {...restProps}
      Container={Container}
      Content={Content}
      blocked={blocked}
      contentProps={{
        ...contentProps,
        inputRef,
      }}
      disabled={disabled}
      hasError={!!error}
      indicatorsProps={{
        ...indicatorsProps,
        SelectedItemsCounter:
          indicatorsProps?.SelectedItemsCounter !== undefined
            ? indicatorsProps.SelectedItemsCounter
            : SelectControlSelectedItemsCounter,
      }}
      ref={ref}
    />
  )
}

export default InputMultiSelectControl
